import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { Button } from '@aimsos/ui';

import { ChevronDown, ChevronUp } from 'lucide-react';

/** "Show emerging (N)" / "Hide emerging" under the Insights grid (CT-5716). */
const InsightEmergingToggle = memo(function InsightEmergingToggle({ count, expanded, onToggle }) {
  const { t } = useTranslation('unified-profiles');

  return (
    <div>
      <Button
        variant="ghost"
        size="sm"
        rightIcon={expanded ? ChevronUp : ChevronDown}
        aria-expanded={expanded}
        onClick={onToggle}
      >
        {expanded ? t('intelligence.insights.emerging.hide') : t('intelligence.insights.emerging.show', { count })}
      </Button>
    </div>
  );
});

export default InsightEmergingToggle;
